import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { startOfWeek, addDays, isSameDay } from '../hooks/dateUtils';
import { ALL_WEEK_DAYS } from '../calendarConstants';

function MobileWeekDaySelector({ selectedDate, onDateChange }) {
  const { t } = useTranslation();

  const weekStart = startOfWeek(selectedDate);
  const today = new Date();

  const days = ALL_WEEK_DAYS.map((day, i) => {
    const date = addDays(weekStart, i);
    return {
      ...day,
      date,
      dayNumber: date.getDate(),
      isSelected: isSameDay(date, selectedDate),
      isToday: isSameDay(date, today),
    };
  });

  return (
    <Box
      sx={{
        flexShrink: 0,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        py: 0.75,
        px: 0.5,
      }}
    >
      {days.map((day) => (
        <Box
          key={day.index}
          onClick={() => onDateChange(day.date)}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            minWidth: 40,
            py: 0.5,
            borderRadius: 2,
            '&:active': { bgcolor: 'action.hover' },
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontSize: '10px',
              fontWeight: 500,
              color: day.isSelected ? 'primary.main' : 'text.secondary',
              textTransform: 'lowercase',
              lineHeight: 1.2,
            }}
          >
            {t(day.shortKey)}
          </Typography>
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: day.isSelected ? 'primary.main' : 'transparent',
              border: day.isToday && !day.isSelected ? '2px solid' : 'none',
              borderColor: 'primary.main',
              mt: 0.25,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: day.isSelected || day.isToday ? 700 : 400,
                fontSize: '13px',
                color: day.isSelected ? 'primary.contrastText' : 'text.primary',
                lineHeight: 1,
              }}
            >
              {day.dayNumber}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default MobileWeekDaySelector;
